export const widthFirstCol = '10rem';
export const widthColTable = '4rem';

export const allGroupValue = 'all';
